import { createFileRoute } from '@tanstack/react-router'
import { EventTypeEditorPage } from '../../../../modules/bookings/event-type-editor-page'

export const Route = createFileRoute('/_authed/bookings/event-types/$id')({
  component: EventTypeEditorRoute,
})

function EventTypeEditorRoute() {
  const { id } = Route.useParams()
  return <EventTypeEditorPage eventTypeId={id} />
}
